module.exports = __webpack_public_path__ + "static/media/4.fe197ed0.jpg";